<template>
  <div class="user-center-root">
    <div class="user-title">
      <!-- <div class="avatar">
        <img :src="avatarUrl" alt="">
      </div> -->
      <!-- <div class="user-name">
        <div class="name">
          {{userName}}
        </div>
        <div class="duration">观看时长</div>
      </div> -->
    </div>

    <!-- <div class="user-trace">
      <div>
        <div class="icon-subscribe"></div>
        <div class="my-sub">我的订阅</div>
      </div>
      <div class="recent-view">
        <div class="title">
          <div class="icon-recent">
          </div>
          <div class="recent-title">最近观看</div>
        </div>
        <div class="list">
          <router-link v-for="item in latestWatch" :key="item.courseID" :to="'/video/' + item.courseID" class="list-title">
            <div class="watch-title">{{item.name}}</div>
            <div class="progress">看到{{item.playRatio > 1 ? '100' : (item.playRatio * 100).toFixed(2)}}%</div>
          </router-link>
        </div>
      </div>

    </div> -->

    <!-- <div class="user-bottom">
      <router-link to="/mine">
        <div>个人中心</div>
      </router-link>
    </div> -->
  </div>
</template>

<script>
// import {getLatestWatched} from '@/api/header'
export default {
  props: ['latestWatch'],
  name: 'UserCenterCard',
  computed: {
    userName () {
      return this.$store.state.userName
    },
    avatarUrl () {
      return this.$store.state.avatarUrl
    }
  },
  created () {
  }

}
</script>

<style scoped>
.user-center-root {
  line-height: initial;
}
.user-title {
  overflow: hidden;
  margin-top: 15px;
  margin-left: 5px;
}
.avatar {
  float:left;
  width: 40px;
  height: 40px;
  background-color: aquamarine;
  border-radius: 50%;
}
.user-name {
  float: left;
  margin-left: 10px;
}
.user-name .name {
  font-size: 14px;
  color: #4A4A4A;
  font-weight: initial;
}
.duration {
  font-size: 12px;
  margin-top: 2px;
}
.user-trace {
  margin-top: 15px;
  margin-left: 15px;
  font-size: 14px;
  font-weight: initial;
  color: #979797;
  line-height: 1;
  margin-bottom: 15px;
}
.user-trace .title {
  overflow: hidden;
}
.user-trace > div {
  overflow: hidden;
}
.icon-subscribe {
  width: 15px;
  height: 17px;
  float: left;
  background: url('../assets/subscribe.png') 100%
}
.icon-recent {
  width: 14px;
  height: 15px;
  float: left;
  background: url('../assets/recent.png') 100%
}
.my-sub, .recent-title {
  margin-left: 10px;
  float: left;
}
.recent-view {
  margin-top: 15px;
}
.recent-view .title {
  margin-bottom: 10px;
}
.user-bottom {
  overflow: hidden;
  padding-top: 3px;
  padding-bottom: 3px;
  background-color: #5CADFF;
  /* border: 1px solid #979797; */
}
.user-bottom:hover {
  background-color: #97CBFF;
}

.user-bottom div {
  padding: 0px 5px;
  width: 50%;
  box-sizing: border-box;
  text-align: center;
  margin: 0 auto;
  color: #fff;
}
.user-bottom > div:first-child {
  border-right: 1px solid #979797;
}
.avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.recent-view .list > div {
  overflow: hidden;
  margin-right: 10px;
}
.recent-view .list {
  font-size: 10px;
  font-weight: 300;
}
.watch-title {
  float: left;
  white-space: nowrap;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.progress {
  float: right;
}

.list .list-title {
  display: inline-block;
  margin-bottom: 5px;
  color: #979797;
}
.list-title:hover {
  color: #fa8919;
}
</style>



// WEBPACK FOOTER //
// src/components/UserCenterCard.vue